<template>
  <div class="iqos-actions">
    <BaseButton
      variant="tertiary"
      color="v1-grey-10"
      :size="size"
      icon="edit-02"
      @click="onEdit"
      v-if="!editing"
    />
    <BaseButton
      variant="primary"
      color="red-4"
      :size="size"
      icon="x"
      class="mr-8"
      @click="onCancel"
      v-if="editing && canCancel"
    />
    <BaseButton
      variant="primary"
      color="green-5"
      :size="size"
      @click="onAccept"
      v-if="editing"
    >
      {{ $t("iqos_actions.save") }}
    </BaseButton>
  </div>
</template>

<script>
import ScrollInverse from "@/services/scrollinverse";

export default {
  props: {
    editing: Boolean,
    canCancel: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: "sm",
    },
  },
  model: {
    prop: "editing",
  },
  methods: {
    onEdit() {
      this.$emit("edit");
      this.$emit("input", true);

      ScrollInverse.lock();
    },
    onCancel() {
      this.$emit("cancel");
      this.$emit("input", false);
      ScrollInverse.unlock();
    },
    onAccept() {
      this.$emit("accept");
      this.$emit("input", false);
      ScrollInverse.unlock();
    },
  },
  components: {},
};
</script>

<style scoped>
.iqos-actions {
  display: flex;
}
</style>
